class IdGenerator {
  generate(prefix = "_") {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return (
      prefix +
      this.dateStr() +
      Math.random()
        .toString(36)
        .substr(2, 5)
        .toUpperCase()
    );
  }

  dateStr() {
    let date = new Date();
    let year = date
      .getFullYear()
      .toString()
      .substr(2, 2);
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let day = date
      .getDate()
      .toString()
      .padStart(2, "0");

    return year + month + day;
  }
}

export default new IdGenerator();
